<ng-container *ngIf="isLoading; else list">
  <ul>
    <li *ngFor="let s of skeletons" data-dgat="panel-list-352">
      <dgx-skeleton type="dashboardNav"></dgx-skeleton>
    </li>
  </ul>
</ng-container>

<ng-template #list>
  <div *ngIf="totalNumItems > 0" class="guts-p-b-3">
    <h4 class="h3 guts-p-b-1">
      {{ collectionName }}
    </h4>

    <ng-content></ng-content>

    <div class="guts-p-t-1" *ngIf="showViewMore">
      <a
        *ngIf="linkData"
        [routerLink]="[linkData.route]"
        [state]="{ searchTerm: linkData.searchTerm }"
        [queryParams]="{ term: linkData.searchTerm || null }"
        (click)="trackLinkClick()"
        class="link par--small font-medium"
        data-dgat="panel-list-46c"
      >
        {{
          'LearningSearch_MoreFormat'
            | translate
              : {
                  count: totalNumItems - maxDisplayedItems,
                  itemname: collectionName
                }
        }}
        <df-icon icon="chevron-right" class="v-top" size="small"></df-icon>
      </a>
    </div>
  </div>
</ng-template>
